import { i18n } from '@/i18n/i18n'
import configuration from '@/agilis/util/Configuration'
import jsonLogic from 'json-logic-js'

const decodeJsonLogic = (data) => {
  if (data && data.jsonLogic) {
    return jsonLogic.uses_data(data)
  }
  return undefined
}
export default {

  /* the data table configuration api */
  listTable: {
    paginatedRequestBody (dataTableConfig, options = {}, _searchTxt = '', filterArray = [], filterHeaders = []) {
      let body = null
      const itemlayout = dataTableConfig?.mobile?.itemLayout
      let headers = decodeJsonLogic(itemlayout?.header) ?? this.getHeader(itemlayout, dataTableConfig).value
      let subHeaders = decodeJsonLogic(itemlayout?.subHeader) ?? this.getSubHeader(itemlayout, dataTableConfig)?.value
      let elements = this.getColumnsId(itemlayout, dataTableConfig)
      const columnArray = [
        elements.filter(col => col !== undefined).map(col => col.value),
        headers,
        subHeaders
      ].flat()
      const searchTxt = _searchTxt ? _searchTxt.trim() : ''
      let dataTableConfigColumnsMobile = []
      const columnSet = new Set(columnArray)
      Object.values(dataTableConfig.columns).forEach(column => {
        if (columnSet.has(column.id)) {
          dataTableConfigColumnsMobile.push(column)
        }
      })
      if (searchTxt) {
        dataTableConfig = { ...dataTableConfig, columns: dataTableConfigColumnsMobile }
      }
      body = configuration.datatable.paginatedRequestBody(dataTableConfig, options, searchTxt, filterArray, filterHeaders)
      return body
    },
    getColumnsId (itemLayout, dataTableConfig) {
      let columnsId = []
      itemLayout.elements.forEach(column => {
        columnsId.push(this.createResultObject(dataTableConfig.columns[column]))
      })
      return columnsId
    },
    getHeader (itemLayout, dataTableConfig) {
      let headerMobile
      headerMobile = this.createResultObject(dataTableConfig.columns[itemLayout.header])
      return {
        ...headerMobile
      }
    },
    getSubHeader (itemLayout, dataTableConfig) {
      let subHeaderMobile
      subHeaderMobile = this.createResultObject(dataTableConfig.columns[itemLayout.subHeader])
      return {
        ...subHeaderMobile
      }
    },
    getIcon (itemLayout) {
      return itemLayout.icon
    },
    createResultObject (configElement) {
      let resultObject
      if (configElement !== undefined) {
        resultObject = {
          value: configElement.id,
          text: configElement.label ? i18n.t(configElement.label) : configElement.id
        }
      }
      return resultObject
    }
  },
  detailGrid: {
    getGrid (detailConfig) {
      return Object.values(detailConfig.row).map(row => {
        return {
          id: row.col.id,
          size: row.col.cols
        }
      })
    }
  }
}
